import React, { useEffect } from "react";

import ToggleSwitch from "../../../../../CommonComponents/ToggleSwitch/ToggleSwitch";

import { BRAND_ICONS_URLS, PERSONAL_LIMITS } from "../../../../../../utils/Constants";
import moneyFormatter from "../../../../../../utils/MoneyFormatter";
import RebetLoader from "../../../../../CommonComponents/RebetLoader/RebetLoader";
import { AppStrings } from "../../../../../../utils/constants/AppStrings";

// import { Container } from './styles';

function CasinoLimits({
  getUserPersonalLimit,
  userPersonalLimit,
  setTitle,
  setIsViewPersonalLimitsPopupVisible,
  setIsEditCasinoLimitsPopupVisible,
  isApiRunning,
  setEditingMode,
}) {
  const handleEditClick = (section) => {
    setEditingMode(true);
    switch (section) {
      case PERSONAL_LIMITS.CASINO_LIMITS:
        setTitle(AppStrings.EDIT_CASINO_LIMITS);
        setIsViewPersonalLimitsPopupVisible(false);
        setIsEditCasinoLimitsPopupVisible(true);
        break;
      default:
        break;
    }
  };

  console.log("userPersonalLimit", userPersonalLimit);

  useEffect(() => {
    getUserPersonalLimit(false);
  }, []);

  return (
    <div className="personal-limits-body">
      {isApiRunning ? (
        <RebetLoader />
      ) : (
        <>
          <div className="personal-limits-section-container">
            <div className="personal-limits-section-header">
                {AppStrings.CASINO_WAGER_LIMITS}
              <span
                className="personal-limits-edit-button"
                onClick={() => handleEditClick(PERSONAL_LIMITS.CASINO_LIMITS)}
              >
                  {AppStrings.EDIT}
              </span>
            </div>
            <div className="personal-limits-section-body">
              <div className="personal-limits-section-item border-bottom">
                <div>
                  <div className="personal-limits-section-item-label">
                      {AppStrings.MAX_CASINO_WAGER_AMOUNT_OF} <br /> {AppStrings.SECONDARY_CURRENCY_PER_DAY}
                    </div>    
                  <div className="personal-limits-section-item-value">
                    <img
                        src={process.env.REACT_APP_ADMIN_PANEL_CLOUDFRONT_URL + BRAND_ICONS_URLS.secondaryCurrencySymbol}
                      alt="Coin Icon"
                      width={15}
                      height={15}
                    />
                    <span>
                        {userPersonalLimit.max_casino_coin_wagered_per_day !== false
                        ? moneyFormatter(
                          userPersonalLimit.max_casino_coin_wagered_per_day
                          )
                        : "-"}
                    </span>
                  </div>
                </div>
                <ToggleSwitch
                    status={userPersonalLimit.max_casino_coin_wagered_per_day}
                  eventCode={"123"}
                  updateEventCode={() => {}}
                />
              </div>
              <div className="personal-limits-section-item">
                <div>
                  <div className="personal-limits-section-item-label">
                      {AppStrings.MAX_CASINO_WAGER_AMOUNT_OF} <br /> {AppStrings.PRIMARY_CURRENCY_PER_DAY}
                  </div>
                  <div className="personal-limits-section-item-value">
                    <img
                        src={process.env.REACT_APP_ADMIN_PANEL_CLOUDFRONT_URL + BRAND_ICONS_URLS.primaryCurrencySymbol}
                      alt="Cash Icon"
                      width={15}
                      height={15}
                    />
                    <span>
                        {userPersonalLimit.max_casino_cash_wagered_per_day !== false
                        ? moneyFormatter(
                          userPersonalLimit.max_casino_cash_wagered_per_day
                          )
                        : "-"}
                    </span>
                  </div>
                </div>
                <ToggleSwitch
                    status={userPersonalLimit.max_casino_cash_wagered_per_day}
                  eventCode={"123"}
                  updateEventCode={() => {}}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default CasinoLimits;
